export const TertiaryButton = ({ onClick, children, className, disabled }) => {
  return (
    <button className={`${className || ''} btn p-0 text-primary-500`} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};
